export enum PartnerType {
  AIRLINE = 'airline',
  CHANNEL = 'channel',
  DISTRIBUTOR = 'distributor',
  PLATFORM = 'platform',
}
